export const states = [
    {
        state: 'Phase 0',
        title: 'Concept and MVP development',
        date: 'Q2 2017 - Q4 2017',
        descriptions:
          [
            'Whitepaper and peer review',
            'Model simulations',
            'Core system',
            'Loan and lock functions',
            'Internal exchange',
            'Initial security reviews',
            'System testing'
          ],
    },
    {
        state: 'Phase 1.0',
        title: 'Limited Pilot',
        date: 'Q1 2018 - Q2 2018',
        descriptions:
          [
            'Pilot with 20-50 users by invitation',
            '1st fiat exchange integration',
            '2 webshop integration for test',
            'Token migrations and contract upgrade tests',
            'Project legal framework',
            'Further security audits'
          ],
    },
    {
        state: 'Phase 1.1',
        title: 'Further pilots',
        date: 'Q2 2018 - Q3 2018',
        descriptions:
          [
            'Multiple pilots with 300+ users',
            '1st ATM in operation for test',
            'Security audits and bug bounties',
            'New site with advanced UI',
            'New additional collateral (tokenized ERC20)',
            'Extended monatery board'
          ],
    },
    {
        state: 'Phase 2.0',
        title: 'Go public',
        date: 'Q3 2018 - Q2 2019',
        descriptions:
          [
            '1000 users',
            '3 fiat exchange integrations',
            '10 ATMs in operation',
            '3rd party wallet app integration',
            '2 new, tokenized ERC20 collateral',
            'Extra audits',
            'Setup for B2B use',
            'Ability to spend A€ without ETH balance'
          ],
    },
    {
        state: 'Phase 2.1',
        title: 'Online commercial',
        date: 'Q2 2019 - Q1 2020',
        descriptions:
          [
            '1000 transactions /day',
            'Introducing A-USD (A$)',
            'Acceptance on a respected fiat exchange',
            'E-commerce plugins',
            'Own mobile wallet app(s)',
            'Fast and cheap transfer and transactions',
            'Introducing margin type loan',
            'Non ETH crypto collateral added',
            'Introducing ATC tokens',
            'Earning distribution contract'
          ],
    },
    {
        state: 'Phase 3',
        title: 'Offline commercial & fully trustless operation',
        date: 'Q2 2020 - Q2 2021',
        descriptions:
          [
            'Worldwide expansion',
            '5000 POS & 500 ATM',
            'Accepted on major fiat exchanges',
            'Trustless DAO operation',
            'Introducing public voting tokens (GDC)',
            'Trustless voting, elected monetary board',
            'Fully trustless rates feed'
          ],
    },
    {
        state: 'Phase 4',
        title: 'Worldwide token',
        date: 'Q3 2021 - ',
        descriptions:
          [
            'Own blockchain',
            'Augmint has alternate to top 5 fiat currencies',
            'Liquid democracy style voting',
            'Ambassadors in at least 100 countries'
          ],
    }
];
